import { number, object, string } from 'yup';
import { SentimentType, TriggerState } from '../states/priceAlertsAtom';

export const priceAlertSchema = object().shape({
  instrument: object().required(),
  activationPrice: number().moreThan(0).required(),
  sentiment: string().oneOf(Object.values(SentimentType)).required(),
  condition: string().oneOf(Object.values(TriggerState)).required(),
  comment: string()
    .notRequired()
    .transform((value, originalValue) => (!originalValue ? undefined : value))
    .max(150),
});
